// extracted by mini-css-extract-plugin
export default {"walletV2Container":"walletV2ContainerZKBcL"};